export class Usuario {
    id: number;
    nome: string;
    email: string;
    roles: string[] = [];
    ativo: boolean;
    uuid: string;
    modulos: string[] = [];
}

export type Role =
    | "admin"
    | "sve"
    | "mapa";


export enum Modulo {
    SANITARY_ANALYSIS = "SANITARY_ANALYSIS",
    SANITARY_EVENT_RESPONSE = "SANITARY_EVENT_RESPONSE",
    SANITARY_EVENT_ACTIONS = "SANITARY_EVENT_ACTIONS",
    PREMISES = "PREMISES",
    SPREAD_DISEASE = "SPREAD_DISEASE",
    IMPORT = "IMPORT",
}
